import _ from 'lodash';

const getMappedObject = (data, additionalFields) => {
  const formSubmittedStatus = 'submitted';
  // eslint-disable-next-line camelcase
  const {
    channelOriginId,
    brand,
    language,
    tpid,
    eapid,
    pointOfSale,
    campaignId,
  } = additionalFields;
  const mappedResponse = _.cloneDeep({
    initiator: data.initiator,
    product: data.product,
    itinerary: data.itinerary,
    email_address: data.emailAddress,
    phone_number: data.phoneNumber,
    ...(data.pnr && { pnr: data.pnr }),
    status: formSubmittedStatus,
    channel_origin_id: channelOriginId,
    point_of_sale: pointOfSale.length > 0 ? pointOfSale : brand,
    language,
    tpid,
    eapid,
    campaign_id: campaignId,
  });
  return mappedResponse;
};

export default getMappedObject;
